import { createElementId, IQAMap } from '@omaze/app';

import { createDisplayName } from '../../OmazeUI.config';

export const collapseDisplayName: string = createDisplayName('Collapse');

export const COLLAPSE_QA: IQAMap = {
    CONTAINER: createElementId(collapseDisplayName, 'Container'),
};
